import { Link } from 'react-router-dom';
import { PawPrint, Mail, MapPin, Calendar, Instagram } from 'lucide-react';
import { eventInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Section */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="bg-gradient-to-br from-cyan-600 to-teal-600 p-2 rounded-lg">
                <PawPrint className="h-5 w-5 text-white" />
              </div>
              <div className="flex flex-col">
                <span className="font-bold text-white">Paws in the Park</span>
                <span className="text-xs">2026</span>
              </div>
            </div>
            <p className="text-sm text-slate-400">
              Celebrating Hero Dogs and bringing our community together for a day of fun, compassion, and canine appreciation.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-cyan-400 transition-colors">Event Overview</Link></li>
              <li><Link to="/performers" className="hover:text-cyan-400 transition-colors">Hero Masters</Link></li>
              <li><Link to="/vendors" className="hover:text-cyan-400 transition-colors">Vendors</Link></li>
              <li><Link to="/competitions" className="hover:text-cyan-400 transition-colors">Competitions</Link></li>
              <li><Link to="/contact" className="hover:text-cyan-400 transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Event Details */}
          <div>
            <h3 className="text-white font-semibold mb-4">Event Details</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <Calendar className="h-4 w-4 mt-0.5 text-cyan-400 flex-shrink-0" />
                <span>September 6, 2026</span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 mt-0.5 text-cyan-400 flex-shrink-0" />
                <span>Warwick Daniels Lake View Park</span>
              </li>
              <li className="flex items-start space-x-2">
                <Mail className="h-4 w-4 mt-0.5 text-cyan-400 flex-shrink-0" />
                <span>paws@twra.net</span>
              </li>
            </ul>
          </div>

          {/* Social & Newsletter */}
          <div>
            <h3 className="text-white font-semibold mb-4">Stay Connected</h3>
            <p className="text-sm text-slate-400 mb-4">
              Follow us for updates and behind-the-scenes content
            </p>
            <div className="flex space-x-3">
              <a 
                href="https://www.instagram.com/twin_waters_res_assoc/" 
                target="_blank"
                rel="noopener noreferrer"
                className="bg-slate-800 p-2 rounded-lg hover:bg-cyan-600 transition-colors"
                aria-label="Follow us on Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a 
                href="https://twra.net" 
                target="_blank"
                rel="noopener noreferrer"
                className="bg-slate-800 p-2 rounded-lg hover:bg-cyan-600 transition-colors flex items-center justify-center"
                aria-label="Visit TWRA Website"
              >
                <span className="text-xs font-bold">TWRA</span>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-8 pt-8 text-sm text-center text-slate-400">
          <p>&copy; 2026 Twin Waters Residents Association (TWRA). All rights reserved.</p>
          <p className="mt-2">
            {eventInfo.theme} | Visit us at{' '}
            <a 
              href="https://twra.net" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-cyan-400 hover:text-cyan-300 hover:underline"
            >
              TWRA.net
            </a>
          </p>
          <p className="mt-3 text-xs text-slate-500" data-testid="footer-credit">
            Created by Amanda Abbott Web Design
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
